import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const AgricultureProductDamageForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({        
        qualityLossPercentage: props.record.damage.qualityLossPercentage,
        yieldLossPercentage: props.record.damage.yieldLossPercentage,
        totalDamagePercentage: props.record.damage.totalDamagePercentage,
        nonProducedGoodQuantity: props.record.damage.nonProducedGoodQuantity,
        totalLossesPercentage: props.record.damage.totalLossesPercentage
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    if (!isEditMode) return;
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.qualityLossPercentage = elvis(values.qualityLossPercentage);
    newDamage.damage.yieldLossPercentage = elvis(values.yieldLossPercentage);
    newDamage.damage.totalDamagePercentage = elvis(values.totalDamagePercentage);
    newDamage.damage.nonProducedGoodQuantity = elvis(values.nonProducedGoodQuantity);
    newDamage.damage.totalLossesPercentage = elvis(values.totalLossesPercentage);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="agricultureProductDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Agriculture Product"
      />
      <Form.Item label="Quality loss (%)" name="qualityLossPercentage">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Product loss (%)" name="yieldLossPercentage">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Total damage (%)" name="totalDamagePercentage">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Not produced (kg)" name="nonProducedGoodQuantity">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Total loss (%)" name="totalLossesPercentage">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default AgricultureProductDamageForm;